import { Module } from '@nestjs/common';
import { AuditModule } from '../audit/audit.module';
import { ContabilidadModule } from '../contabilidad/contabilidad.module';
import { PrismaModule } from '../prisma/prisma.module';
import { NotaCreditoComprasController } from './nota-credito-compras.controller';
import { NotaCreditoComprasService } from './nota-credito-compras.service';

@Module({
  imports: [PrismaModule, AuditModule, ContabilidadModule],
  controllers: [NotaCreditoComprasController],
  providers: [NotaCreditoComprasService],
  exports: [NotaCreditoComprasService],
})
export class NotaCreditoComprasModule {}
